module.exports = __webpack_public_path__ + "img/crisis_hotline.c6bcb95c.png";